export default __webpack_public_path__ + "static/media/postit.76be7150.png";